var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt1Dollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3555_79959)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05168 0.117874L0.0211699 10.6845C0.0020273 10.7238 -0.00403885 10.7682 0.00385851 10.8112C0.0117559 10.8542 0.0332024 10.8935 0.0650619 10.9234L13.6513 23.9423C13.6899 23.9793 13.7413 24 13.7947 24C13.8482 24 13.8996 23.9793 13.9382 23.9423L27.5244 10.9243C27.5563 10.8943 27.5777 10.855 27.5856 10.812C27.5935 10.769 27.5874 10.7246 27.5683 10.6853L22.5378 0.118687C22.5215 0.0831997 22.4954 0.0531376 22.4626 0.0320934C22.4297 0.0110491 22.3915 -8.70516e-05 22.3525 1.57299e-05H5.23863C5.19942 -0.000472091 5.16091 0.0103958 5.12774 0.0313085C5.09456 0.0522212 5.06815 0.0822852 5.05168 0.117874Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5402 11.7691C15.4427 11.7765 14.9387 11.8065 13.8146 11.8065C12.9205 11.8065 12.2857 11.7797 12.063 11.7691C8.60769 11.6171 6.02863 11.0157 6.02863 10.2955C6.02863 9.57535 8.60769 8.97468 12.063 8.82025V11.1701C12.2889 11.1864 12.9359 11.2246 13.83 11.2246C14.9029 11.2246 15.4402 11.1799 15.5369 11.1709V8.82187C18.9849 8.9755 21.5583 9.57698 21.5583 10.2955C21.5583 11.014 18.9857 11.6155 15.5369 11.7683L15.5402 11.7691ZM15.5402 8.57884V6.47609H20.3521V3.26953H7.2511V6.47609H12.0622V8.57803C8.1517 8.75766 5.21094 9.53227 5.21094 10.4605C5.21094 11.3887 8.1517 12.1625 12.0622 12.343V19.0812H15.5394V12.3406C19.4409 12.1609 22.3768 11.3871 22.3768 10.4597C22.3768 9.53227 19.4433 8.75847 15.5394 8.57803L15.5402 8.57884Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3555_79959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5894,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt1Dollar);
export default __webpack_public_path__ + "static/media/USDT 1_dollar.5195aa986fc12e70580129d81ca7a649.svg";
export { ForwardRef as ReactComponent };